<template>
  <form
    method="POST"
    action="https://bountixp.activehosted.com/proc.php"
    id="_form_4_"
    class="_form _form_4 _inline-form _dark"
    novalidate
  >
    <input type="hidden" name="u" value="4" />
    <input type="hidden" name="f" value="4" />
    <input type="hidden" name="s" />
    <input type="hidden" name="c" value="0" />
    <input type="hidden" name="m" value="0" />
    <input type="hidden" name="act" value="sub" />
    <input type="hidden" name="v" value="2" />
    <input type="hidden" name="or" value="108727a115d7b6e5cc72fd6c71dda963" />
    <div class="_form-content">
      <div class="_form_element _x57972595 _full_width _clear">
        <div class="_form-title">Get in touch</div>
      </div>
      <div class="_form_element _x30055526 _full_width _clear">
        <div class="_form-title">
          Schedule a conversation with us so we can understand your needs and
          discuss how bountiXP can help you.
        </div>
      </div>
      <div class="_form_element _x88834987 _full_width">
        <label for="firstname" class="_form-label"> First Name* </label>
        <div class="_field-wrapper">
          <input
            type="text"
            id="firstname"
            name="firstname"
            placeholder="Type your first name"
            required
          />
        </div>
        <!--  This STARTS the Custom Objects section  -->
      </div>
      <div class="_form_element _x82899770 _full_width">
        <label for="lastname" class="_form-label"> Last Name* </label>
        <div class="_field-wrapper">
          <input
            type="text"
            id="lastname"
            name="lastname"
            placeholder="Type your last name"
            required
          />
        </div>
        <!--  This STARTS the Custom Objects section  -->
      </div>
      <div class="_form_element _x13562508 _full_width">
        <label for="email" class="_form-label"> Email* </label>
        <div class="_field-wrapper">
          <input
            type="text"
            id="email"
            name="email"
            placeholder="Type your email address"
            required
          />
        </div>
        <!--  This STARTS the Custom Objects section  -->
      </div>
      <div class="_form_element _x17123533 _full_width">
        <label for="phone" class="_form-label"> Mobile Number* </label>
        <div class="_field-wrapper">
          <input
            type="text"
            id="phone"
            name="phone"
            placeholder="Type your mobile number"
            required
          />
        </div>
        <!--  This STARTS the Custom Objects section  -->
      </div>
      <div class="_form_element _field13 _full_width">
        <label for="field[13]" class="_form-label"> Country* </label>
        <div class="_field-wrapper">
          <select name="field[13]" id="field[13]" required>
            <option selected></option>
            <option value="United Kingdom">United Kingdom</option>
            <option value="South Africa">South Africa</option>
            <option value="Other">Other</option>
          </select>
        </div>
      </div>
      <div class="_form_element _field14 _full_width">
        <label for="field[14]" class="_form-label"> Company Name* </label>
        <div class="_field-wrapper">
          <input
            type="text"
            id="field[14]"
            name="field[14]"
            value=""
            placeholder=""
            required
          />
        </div>
      </div>
      <div class="_form_element _field17 _full_width">
        <label for="field[17]" class="_form-label">
          Number of Employees*
        </label>
        <div class="_field-wrapper">
          <textarea
            id="field[17]"
            name="field[17]"
            placeholder=""
            required
          ></textarea>
        </div>
      </div>
      <div class="_form_element _field16 _full_width">
        <label for="field[16]" class="_form-label"> Message </label>
        <div class="_field-wrapper">
          <textarea id="field[16]" name="field[16]" placeholder=""></textarea>
        </div>
      </div>
      <div class="_form_element _field3 _full_width">
        <input type="hidden" name="field[3]" value="" />
      </div>
      <div class="_form_element _field4 _full_width">
        <input type="hidden" name="field[4]" value="" />
      </div>
      <div class="_form_element _field5 _full_width">
        <input type="hidden" name="field[5]" value="" />
      </div>
      <div class="_form_element _field6 _full_width">
        <input type="hidden" name="field[6]" value="" />
      </div>
      <div class="_form_element _field7 _full_width">
        <input type="hidden" name="field[7]" value="" />
      </div>
      <div class="_form_element _field8 _full_width">
        <input type="hidden" name="field[8]" value="" />
      </div>
      <div class="_form_element _field9 _full_width">
        <input type="hidden" name="field[9]" value="" />
      </div>
      <div class="_form_element _field10 _full_width">
        <input type="hidden" name="field[10]" value="" />
      </div>
      <div class="_form_element _field11 _full_width">
        <input type="hidden" name="field[11]" value="" />
      </div>
      <div class="_button-wrapper _full_width">
        <button id="_form_4_submit" class="_submit" type="submit">
          Submit
        </button>
      </div>
      <div class="_clear-element"></div>
    </div>
    <div class="_form-thank-you" style="display: none"></div>
  </form>
</template>



<script>
import { VueMaskDirective } from "v-mask";
import { formBus } from "@/formBus";
import TabNavigation from "../../../../custom_modules/vue-multistep-form-wizard/src/components/TabNavigation.vue";
// import MfwButton from "../../../../custom_modules/vue-multistep-form-wizard/src/components/MfwButton.vue";
export default {
  components: { TabNavigation },
  directives: {
    mask: VueMaskDirective,
  },
  data() {
    return {
      error: false,
      loadingScreen: {
        show: false,
        success: false,
      },
    };
  },
  computed: {
    fields() {
      return formBus.fields;
    },
    stepValid() {
      return (
        this.fields.firstName.valid &&
        this.fields.lastName.valid &&
        this.fields.country.valid &&
        this.fields.mobileNumber.valid &&
        this.fields.employeeCount.valid &&
        this.fields.email.valid &&
        this.fields.companyName.valid &&
        this.fields.termsAccepted
      );
    },
    emailValue: {
      get() {
        return this.fields.email.value;
      },
      set(val) {
        formBus.fields.email.loading = true;
        val = val.trim();
        formBus.fields.email.value = val;
        this.resetValidation("email", val);
        if (formBus.fields.email.timer !== null) {
          clearTimeout(formBus.fields.email.timer);
        }
        formBus.fields.email.timer = setTimeout(
          async (val) => {
            const emailValidation = await this.validateEmail(val);
            this.updateValidation(
              "email",
              emailValidation.valid,
              emailValidation.message
            );
            formBus.fields.email.loading = false;
          },
          2500,
          val
        );
      },
    },
    countryValue: {
      get() {
        return this.fields.country.value;
      },
      set(val) {
        formBus.fields.country.value = val;
        this.validateCountry(val);
        valid = true;
      },
    },
    mobileNumberValue: {
      get() {
        return this.fields.mobileNumber.value;
      },
      set(val) {
        formBus.fields.mobileNumber.value = val;
      },
    },
  },
  methods: {
    updateFirstName(val) {
      this.fields.firstName.value = val;
      let valid = null;
      let message = null;
      if (val === "") {
        valid = false;
        message = "This field is incomplete";
      } else {
        valid = true;
        message = null;
      }
      this.updateValidation("firstName", valid, message);
    },
    updateLastName(val) {
      this.fields.lastName.value = val;
      let valid = null;
      let message = null;
      if (val === "") {
        valid = false;
        message = "This field is incomplete";
      } else {
        valid = true;
        message = null;
      }
      this.updateValidation("lastName", valid, message);
    },
    updateCompanyName(val) {
      this.fields.companyName.value = val;
      let valid = null;
      let message = null;
      if (val === "") {
        valid = false;
        message = "This field is incomplete";
      } else {
        valid = true;
        message = null;
      }
      this.updateValidation("companyName", valid, message);
    },
    updatePhoneNumber(val) {
      this.fields.mobileNumber.value = val;
      let valid = null;
      let message = null;
      if (val === "") {
        valid = false;
        message = "This field is incomplete";
      } else {
        valid = true;
        message = null;
      }
      this.updateValidation("mobileNumber", valid, message);
    },
    updateEmployees(val) {
      this.fields.employeeCount.value = val;
      let valid = null;
      let message = null;
      if (val === "") {
        valid = false;
        message = "This field is incomplete";
      } else {
        valid = true;
        message = null;
      }
      this.updateValidation("employeeCount", valid, message);
    },
    messageValue(val) {
      this.fields.message.value = val;
      let valid = null;
      let message = null;
      if (val === "") {
        valid = false;
        message = "This field is incomplete";
      } else {
        valid = true;
        message = null;
      }
      this.updateValidation("message", true, message);
    },
    async validateEmail(email) {
      //Empty field
      if (email === "") {
        return {
          valid: false,
          message: "This field is incomplete",
        };
      }
      //Email format
      const validCriteria =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!validCriteria.test(email)) {
        return {
          valid: false,
          message: "Please enter a valid email address",
        };
      }
      //Uses a domain that's not blacklisted as non-work emails
      if (!this.isWorkEmail(email)) {
        return {
          valid: false,
          message: "Please enter your work email address",
        };
      }
      return {
        valid: true,
        message: null,
      };
    },
    submitform() {
      window.cfields = {
        13: "country",
        14: "company_name",
        17: "number_of_employees",
        16: "message",
        3: "httpreferrer",
        4: "ctareferrer",
        5: "product",
        6: "producttitle",
        7: "plan",
        8: "term",
        9: "currency",
        10: "usercount",
        11: "monthlybasecost",
      };
      window._show_thank_you = function (id, message, trackcmp_url, email) {
        var form = document.getElementById("_form_" + id + "_"),
          thank_you = form.querySelector("._form-thank-you");
        form.querySelector("._form-content").style.display = "none";
        thank_you.innerHTML = message;
        thank_you.style.display = "block";
        const vgoAlias =
          typeof visitorGlobalObjectAlias === "undefined"
            ? "vgo"
            : visitorGlobalObjectAlias;
        var visitorObject = window[vgoAlias];
        if (email && typeof visitorObject !== "undefined") {
          visitorObject("setEmail", email);
          visitorObject("update");
        } else if (typeof trackcmp_url != "undefined" && trackcmp_url) {
          // Site tracking URL to use after inline form submission.
          _load_script(trackcmp_url);
        }
        if (typeof window._form_callback !== "undefined")
          window._form_callback(id);
      };
      window._show_error = function (id, message, html) {
        var form = document.getElementById("_form_" + id + "_"),
          err = document.createElement("div"),
          button = form.querySelector("button"),
          old_error = form.querySelector("._form_error");
        if (old_error) old_error.parentNode.removeChild(old_error);
        err.innerHTML = message;
        err.className = "_error-inner _form_error _no_arrow";
        var wrapper = document.createElement("div");
        wrapper.className = "_form-inner";
        wrapper.appendChild(err);
        button.parentNode.insertBefore(wrapper, button);
        document.querySelector('[id^="_form"][id$="_submit"]').disabled = false;
        if (html) {
          var div = document.createElement("div");
          div.className = "_error-html";
          div.innerHTML = html;
          err.appendChild(div);
        }
      };
      window._load_script = function (url, callback) {
        var head = document.querySelector("head"),
          script = document.createElement("script"),
          r = false;
        script.type = "text/javascript";
        script.charset = "utf-8";
        script.src = url;
        if (callback) {
          script.onload = script.onreadystatechange = function () {
            if (!r && (!this.readyState || this.readyState == "complete")) {
              r = true;
              callback();
            }
          };
        }
        head.appendChild(script);
      };
      (function () {
        if (window.location.search.search("excludeform") !== -1) return false;
        var getCookie = function (name) {
          var match = document.cookie.match(
            new RegExp("(^|; )" + name + "=([^;]+)")
          );
          return match ? match[2] : null;
        };
        var setCookie = function (name, value) {
          var now = new Date();
          var time = now.getTime();
          var expireTime = time + 1000 * 60 * 60 * 24 * 365;
          now.setTime(expireTime);
          document.cookie = name + "=" + value + "; expires=" + now + ";path=/";
        };
        var addEvent = function (element, event, func) {
          if (element.addEventListener) {
            element.addEventListener(event, func);
          } else {
            var oldFunc = element["on" + event];
            element["on" + event] = function () {
              oldFunc.apply(this, arguments);
              func.apply(this, arguments);
            };
          }
        };
        var _removed = false;
        var form_to_submit = document.getElementById("_form_4_");
        var allInputs = form_to_submit.querySelectorAll(
            "input, select, textarea"
          ),
          tooltips = [],
          submitted = false;

        var getUrlParam = function (name) {
          var params = new URLSearchParams(window.location.search);
          return params.get(name) || false;
        };

        for (var i = 0; i < allInputs.length; i++) {
          var regexStr = "field\\[(\\d+)\\]";
          var results = new RegExp(regexStr).exec(allInputs[i].name);
          if (results != undefined) {
            allInputs[i].dataset.name = window.cfields[results[1]];
          } else {
            allInputs[i].dataset.name = allInputs[i].name;
          }
          var fieldVal = getUrlParam(allInputs[i].dataset.name);

          if (fieldVal) {
            if (allInputs[i].dataset.autofill === "false") {
              continue;
            }
            if (
              allInputs[i].type == "radio" ||
              allInputs[i].type == "checkbox"
            ) {
              if (allInputs[i].value == fieldVal) {
                allInputs[i].checked = true;
              }
            } else {
              allInputs[i].value = fieldVal;
            }
          }
        }

        var remove_tooltips = function () {
          for (var i = 0; i < tooltips.length; i++) {
            tooltips[i].tip.parentNode.removeChild(tooltips[i].tip);
          }
          tooltips = [];
        };
        var remove_tooltip = function (elem) {
          for (var i = 0; i < tooltips.length; i++) {
            if (tooltips[i].elem === elem) {
              tooltips[i].tip.parentNode.removeChild(tooltips[i].tip);
              tooltips.splice(i, 1);
              return;
            }
          }
        };
        var create_tooltip = function (elem, text) {
          var tooltip = document.createElement("div"),
            arrow = document.createElement("div"),
            inner = document.createElement("div"),
            new_tooltip = {};
          if (elem.type != "radio" && elem.type != "checkbox") {
            tooltip.className = "_error";
            arrow.className = "_error-arrow";
            inner.className = "_error-inner";
            inner.innerHTML = text;
            tooltip.appendChild(arrow);
            tooltip.appendChild(inner);
            elem.parentNode.appendChild(tooltip);
          } else {
            tooltip.className = "_error-inner _no_arrow";
            tooltip.innerHTML = text;
            elem.parentNode.insertBefore(tooltip, elem);
            new_tooltip.no_arrow = true;
          }
          new_tooltip.tip = tooltip;
          new_tooltip.elem = elem;
          tooltips.push(new_tooltip);
          return new_tooltip;
        };
        var resize_tooltip = function (tooltip) {
          var rect = tooltip.elem.getBoundingClientRect();
          var doc = document.documentElement,
            scrollPosition =
              rect.top -
              ((window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0));
          if (scrollPosition < 40) {
            tooltip.tip.className =
              tooltip.tip.className.replace(/ ?(_above|_below) ?/g, "") +
              " _below";
          } else {
            tooltip.tip.className =
              tooltip.tip.className.replace(/ ?(_above|_below) ?/g, "") +
              " _above";
          }
        };
        var resize_tooltips = function () {
          if (_removed) return;
          for (var i = 0; i < tooltips.length; i++) {
            if (!tooltips[i].no_arrow) resize_tooltip(tooltips[i]);
          }
        };
        var validate_field = function (elem, remove) {
          var tooltip = null,
            value = elem.value,
            no_error = true;
          remove ? remove_tooltip(elem) : false;
          if (elem.type != "checkbox")
            elem.className = elem.className.replace(/ ?_has_error ?/g, "");
          if (elem.getAttribute("required") !== null) {
            if (
              elem.type == "radio" ||
              (elem.type == "checkbox" && /any/.test(elem.className))
            ) {
              var elems = form_to_submit.elements[elem.name];
              if (
                !(
                  elems instanceof NodeList || elems instanceof HTMLCollection
                ) ||
                elems.length <= 1
              ) {
                no_error = elem.checked;
              } else {
                no_error = false;
                for (var i = 0; i < elems.length; i++) {
                  if (elems[i].checked) no_error = true;
                }
              }
              if (!no_error) {
                tooltip = create_tooltip(elem, "Please select an option.");
              }
            } else if (elem.type == "checkbox") {
              var elems = form_to_submit.elements[elem.name],
                found = false,
                err = [];
              no_error = true;
              for (var i = 0; i < elems.length; i++) {
                if (elems[i].getAttribute("required") === null) continue;
                if (!found && elems[i] !== elem) return true;
                found = true;
                elems[i].className = elems[i].className.replace(
                  / ?_has_error ?/g,
                  ""
                );
                if (!elems[i].checked) {
                  no_error = false;
                  elems[i].className = elems[i].className + " _has_error";
                  err.push(
                    "Checking %s is required".replace("%s", elems[i].value)
                  );
                }
              }
              if (!no_error) {
                tooltip = create_tooltip(elem, err.join("<br/>"));
              }
            } else if (elem.tagName == "SELECT") {
              var selected = true;
              if (elem.multiple) {
                selected = false;
                for (var i = 0; i < elem.options.length; i++) {
                  if (elem.options[i].selected) {
                    selected = true;
                    break;
                  }
                }
              } else {
                for (var i = 0; i < elem.options.length; i++) {
                  if (
                    elem.options[i].selected &&
                    (!elem.options[i].value ||
                      elem.options[i].value.match(/\n/g))
                  ) {
                    selected = false;
                  }
                }
              }
              if (!selected) {
                elem.className = elem.className + " _has_error";
                no_error = false;
                tooltip = create_tooltip(elem, "Please select an option.");
              }
            } else if (value === undefined || value === null || value === "") {
              elem.className = elem.className + " _has_error";
              no_error = false;
              tooltip = create_tooltip(elem, "This field is required.");
            }
          }
          if (no_error && elem.name == "email") {
            if (
              !value.match(
                /^[\+_a-z0-9-'&=]+(\.[\+_a-z0-9-']+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i
              )
            ) {
              elem.className = elem.className + " _has_error";
              no_error = false;
              tooltip = create_tooltip(elem, "Enter a valid email address.");
            }
          }
          if (no_error && /date_field/.test(elem.className)) {
            if (!value.match(/^\d\d\d\d-\d\d-\d\d$/)) {
              elem.className = elem.className + " _has_error";
              no_error = false;
              tooltip = create_tooltip(elem, "Enter a valid date.");
            }
          }
          tooltip ? resize_tooltip(tooltip) : false;
          return no_error;
        };
        var needs_validate = function (el) {
          if (el.getAttribute("required") !== null) {
            return true;
          }
          if (el.name === "email" && el.value !== "") {
            return true;
          }
          return false;
        };
        var validate_form = function (e) {
          var err = form_to_submit.querySelector("._form_error"),
            no_error = true;
          if (!submitted) {
            submitted = true;
            for (var i = 0, len = allInputs.length; i < len; i++) {
              var input = allInputs[i];
              if (needs_validate(input)) {
                if (
                  input.type == "text" ||
                  input.type == "number" ||
                  input.type == "time"
                ) {
                  addEvent(input, "blur", function () {
                    this.value = this.value.trim();
                    validate_field(this, true);
                  });
                  addEvent(input, "input", function () {
                    validate_field(this, true);
                  });
                } else if (input.type == "radio" || input.type == "checkbox") {
                  (function (el) {
                    var radios = form_to_submit.elements[el.name];
                    for (var i = 0; i < radios.length; i++) {
                      addEvent(radios[i], "click", function () {
                        validate_field(el, true);
                      });
                    }
                  })(input);
                } else if (input.tagName == "SELECT") {
                  addEvent(input, "change", function () {
                    validate_field(this, true);
                  });
                } else if (input.type == "textarea") {
                  addEvent(input, "input", function () {
                    validate_field(this, true);
                  });
                }
              }
            }
          }
          remove_tooltips();
          for (var i = 0, len = allInputs.length; i < len; i++) {
            var elem = allInputs[i];
            if (needs_validate(elem)) {
              if (elem.tagName.toLowerCase() !== "select") {
                elem.value = elem.value.trim();
              }
              validate_field(elem) ? true : (no_error = false);
            }
          }
          if (!no_error && e) {
            e.preventDefault();
          }
          resize_tooltips();
          return no_error;
        };
        addEvent(window, "resize", resize_tooltips);
        addEvent(window, "scroll", resize_tooltips);
        var _form_serialize = function (form) {
          if (!form || form.nodeName !== "FORM") {
            return;
          }
          var i,
            j,
            q = [];
          for (i = 0; i < form.elements.length; i++) {
            if (form.elements[i].name === "") {
              continue;
            }
            switch (form.elements[i].nodeName) {
              case "INPUT":
                switch (form.elements[i].type) {
                  case "text":
                  case "number":
                  case "date":
                  case "time":
                  case "hidden":
                  case "password":
                  case "button":
                  case "reset":
                  case "submit":
                    q.push(
                      form.elements[i].name +
                        "=" +
                        encodeURIComponent(form.elements[i].value)
                    );
                    break;
                  case "checkbox":
                  case "radio":
                    if (form.elements[i].checked) {
                      q.push(
                        form.elements[i].name +
                          "=" +
                          encodeURIComponent(form.elements[i].value)
                      );
                    }
                    break;
                  case "file":
                    break;
                }
                break;
              case "TEXTAREA":
                q.push(
                  form.elements[i].name +
                    "=" +
                    encodeURIComponent(form.elements[i].value)
                );
                break;
              case "SELECT":
                switch (form.elements[i].type) {
                  case "select-one":
                    q.push(
                      form.elements[i].name +
                        "=" +
                        encodeURIComponent(form.elements[i].value)
                    );
                    break;
                  case "select-multiple":
                    for (j = 0; j < form.elements[i].options.length; j++) {
                      if (form.elements[i].options[j].selected) {
                        q.push(
                          form.elements[i].name +
                            "=" +
                            encodeURIComponent(
                              form.elements[i].options[j].value
                            )
                        );
                      }
                    }
                    break;
                }
                break;
              case "BUTTON":
                switch (form.elements[i].type) {
                  case "reset":
                  case "submit":
                  case "button":
                    q.push(
                      form.elements[i].name +
                        "=" +
                        encodeURIComponent(form.elements[i].value)
                    );
                    break;
                }
                break;
            }
          }
          return q.join("&");
        };
        var form_submit = function (e) {
          e.preventDefault();
          if (validate_form()) {
            // use this trick to get the submit button & disable it using plain javascript
            document.querySelector("#_form_4_submit").disabled = true;
            var serialized = _form_serialize(
              document.getElementById("_form_4_")
            ).replace(/%0A/g, "\\n");
            var err = form_to_submit.querySelector("._form_error");
            err ? err.parentNode.removeChild(err) : false;
            _load_script(
              "https://bountixp.activehosted.com/proc.php?" +
                serialized +
                "&jsonp=true"
            );
          }
          return false;
        };
        addEvent(form_to_submit, "submit", form_submit);
      })();
    },
  },
};
</script>

<style>
.bxp-form {
  width: 720px !important;
  align-content: center !important;
  justify-content: center !important;
  margin: auto;
}

.get-in-touch {
  height: 40px;
  width: 214px;
  /* color: #a6ce38; */
  color: #282829;
  font-family: Roboto;
  font-size: 40px;
  letter-spacing: 0;
  line-height: 40px;
  margin-bottom: 14px;
}

.schedule-a-conversatation {
  height: 48px;
  width: 700px;
  color: #282829;
  font-family: Roboto;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 24px;
}

.divider-line {
  height: 1px;
  width: 720px;
  background-color: #f6f6f8;
  margin-top: 27px;
}

.contact-us-gridlayout {
  display: grid;
  grid-template-columns: 300px 300px;
  column-gap: 80px;
  justify-content: center;
}

.midwords {
  color: #a6ce38;
  font-weight: bold;
}

.agree-row {
  display: flex;
  flex-direction: row;
  margin-top: 44px;
}
.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.checkbox {
  height: 30px;
  width: 30px;
  margin-right: 10px;
  /* align-content: center !important;
  justify-content: center !important; */
}

.agree-to-terms {
  /* height: 22px; */
  /* width: 281px; */
  color: #a7a7a9;
  font-family: Roboto;
  font-size: 12px;
  /* font-weight: bold; */
  letter-spacing: 0;
  line-height: 22px;
}

.submit-button {
  margin-left: auto;
}

.captcha-text {
  height: 20px;
  width: 445px;
  color: #282829;
  font-family: "Open Sans";
  font-size: 10px;
  letter-spacing: 0;
  line-height: 10px;
}

.divider-line-office {
  height: 1px;
  width: 720px;
  background-color: #f6f6f8;
  margin-top: 62px;
}

.office-header {
  margin-top: 40px;
  height: 40px;
  width: 305px;
  /* color: #A6CE38; */
  font-family: Roboto;
  font-size: 40px;
  letter-spacing: 0;
  line-height: 40px;
}

.office-locations {
  margin-top: 20px;
}

.loc-1-header {
  height: 20px;
  width: 496px;
  color: #282829;
  font-family: Roboto;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 20px;
}

.loc-1-address {
  margin-top: 10px;
  height: 40px;
  width: 600px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
}

.loc-1-email {
  height: 40px;
  width: 600px;
  color: #a6ce38;
  font-family: Roboto;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
}

.loc-2-header {
  height: 20px;
  width: 496px;
  color: #282829;
  font-family: Roboto;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: 40px;
}
</style>